import React, {createContext, useEffect, useState} from 'react';
import EventList from "./events/EventList";
import DocumentList from "./documents/DocumentList";
import './style.css';
import EventCalendar from "./events/EventCalendar";

export const Context = createContext({});

export default function ApiClient(props) {

    let [events, setEvents]                 = useState([]);
    let [documents, setDocuments]           = useState([]);
    let [territories, setTerritories]       = useState([]);
    let [eventThemes, setEventThemes]       = useState([]);
    let [documentThemes, setDocumentThemes] = useState([]);

    useEffect(() => {
        switch (props.resource) {
            case 'events':
            case 'events-list':
                fetchEvents().then(events => setEvents(events));
                fetchTerritories().then(territories => setTerritories(territories));
                fetchEventThemes().then(themes => setEventThemes(themes));
                break;
            case 'documents':
                fetchDocuments().then(documents => setDocuments(documents));
                fetchDocumentThemes().then(themes => setDocumentThemes(themes));
                break;
            default:
                break;
        }

        // eslint-disable-next-line
    }, []);

    const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

    const requestOptions = {
        method: 'GET',
        redirect: 'follow'
    };

    async function fetchEvents() {
        let events = {};

        await fetch(REACT_APP_API_URL + '/events', requestOptions)
            .then(response => response.text())
            .then(result => events = JSON.parse(result))
            .catch(error => console.log('error', error));

        return events;
    }

    async function fetchDocuments() {
        let documents = {};

        await fetch(REACT_APP_API_URL + '/api/documents', requestOptions)
            .then(response => response.text())
            .then(result => documents = JSON.parse(result))
            .catch(error => console.log('error', error));

        return documents;
    }

    async function fetchTerritories() {
        let territories = {};

        await fetch(REACT_APP_API_URL + '/territories', requestOptions)
            .then(response => response.text())
            .then(result => territories = JSON.parse(result))
            .catch(error => console.log('error', error));

        return territories;
    }

    async function fetchEventThemes() {
        let eventThemes = {};

        await fetch(REACT_APP_API_URL + '/events/themes', requestOptions)
            .then(response => response.text())
            .then(result => eventThemes = JSON.parse(result))
            .catch(error => console.log('error', error));

        return eventThemes;
    }

    async function fetchDocumentThemes() {
        let documentThemes = {};

        await fetch(REACT_APP_API_URL + '/documents/themes', requestOptions)
            .then(response => response.text())
            .then(result => documentThemes = JSON.parse(result))
            .catch(error => console.log('error', error));

        return documentThemes;
    }

    return (
        // Value set in provider is an object containing multiple sub objects, so it has to be wrapped in  2 curly braces
        <Context.Provider value={{events, documents, territories, eventThemes, documentThemes}}>
            {
                events.length > 0 && props.resource === 'events-list' && <EventList/>
            }
            {
                events.length > 0 && props.resource === 'events' && <EventCalendar/>
            }
            {
                documents.length > 0 && <DocumentList/>
            }
        </Context.Provider>
    );
}


